import React from 'react';
import './GroundBackgroundSelectButton.css';
import {MaskedIcon, MASKED_ICON_TONES} from '../coloredIcons/MaskedIcon/MaskedIcon';
import {MENU_SOUND_MANAGER} from '../../scenes/MenuSoundManager';
import {sendButtonClickEvent} from '../../analytics/gameAnalytics';
import {
  GROUND_BACKGROUND_CHOICE_TEXT,
  getGroundBackgroundChoiceName,
  getGroundBackgroundPreview,
} from '../../configs/groundBackgroundChoice';

export const GROUND_BACKGROUND_RANDOM_ICON_PATH = '/img/icons/dice roll.png';

/**
 * Строка «Биом: …» на странице настройки локальной партии: показывает
 * нынешний выбор подложки поля (с ее маленькой картинкой) и открывает экран
 * выбора (см. pages/GroundBackgroundSelectPage).
 *
 * @param {string|null} value — идентификатор подложки; null — случайная
 * @param {Function} onClick — открыть экран выбора
 * @param {string} [pageId] — страница, от имени которой пишется метрика клика
 */
function GroundBackgroundSelectButton({value = null, onClick, pageId}) {
  const name = getGroundBackgroundChoiceName(value);
  const preview = getGroundBackgroundPreview(value);

  const handleClick = () => {
    if (pageId) {
      sendButtonClickEvent(pageId, 'ground_background');
    }
    MENU_SOUND_MANAGER.playMenuButtonClick();
    onClick?.();
  };

  return (
    <button
      type="button"
      className="ground-background-select-button"
      onClick={handleClick}
      title={preview
        ? GROUND_BACKGROUND_CHOICE_TEXT.getTooltipChosen(name)
        : GROUND_BACKGROUND_CHOICE_TEXT.tooltipRandom}
    >
      {preview
        ? <img className="ground-background-select-button_preview" src={preview} alt=""/>
        : (
          <MaskedIcon
            className="ground-background-select-button_random-icon"
            src={GROUND_BACKGROUND_RANDOM_ICON_PATH}
            tone={MASKED_ICON_TONES.CONTROLS}
          />
        )}
      <span className="ground-background-select-button_text">{GROUND_BACKGROUND_CHOICE_TEXT.label}: {name}</span>
    </button>
  );
}

export default GroundBackgroundSelectButton;
